import React, { useContext } from 'react';
import getConfig from 'next/config';
import { useApp } from '../../../state/app';
import { useToggles } from '../../../state/toggles';
import { AnalyticsContext } from '../../../ModularReduxAnalytics';

import CreditWaitlistModal from './index';

const { publicRuntimeConfig } = getConfig();

function CreditWaitlistModalContainer(props) {
  const { analytics, segment } = useContext(AnalyticsContext);
  const { answers } = useApp();
  const { creditWaitlistShowConfirmScreen } = useToggles();
  return (
    <CreditWaitlistModal
      email={answers?.setUserEmail}
      firstName={answers?.setLegalFirstName}
      lastName={answers?.setLegalLastName}
      vlCampaignId={`${publicRuntimeConfig.vlCreditWaitlistCampaignId}`}
      showConfirmScreen={creditWaitlistShowConfirmScreen}
      trackPage={segment.page}
      trackEvent={analytics.trackEvent}
    />
  );
}

export default CreditWaitlistModalContainer;
